import {
  ChartArea, ChartBar, ChartBarStacked, ChartColumn, ChartColumnStacked, ChartLine, ChartPie,
  ChartScatter, ChartSpline, Donut, Funnel, Grid3x3, Hash, Layers, LayoutGrid, Percent, Radar, Sparkles, SquareChartGantt, Table, Workflow,
} from 'lucide-react';

/**
 * The chart types a card can be drawn as. Ids match the server's
 * (services/dashboards/charts.js); `needs` is what the rows must have.
 */
export const CHART_TYPES = [
  { id: '', label: 'Auto', icon: Sparkles },
  { id: 'line', label: 'Line', icon: ChartLine },
  { id: 'stacked_line', label: 'Stacked line', icon: ChartSpline, needs: 'split' },
  { id: 'area', label: 'Area', icon: ChartArea },
  { id: 'stacked_area', label: 'Stacked area', icon: Layers, needs: 'split' },
  { id: 'percent_area', label: '100% area', icon: Percent, needs: 'split' },
  { id: 'bar', label: 'Column', icon: ChartColumn },
  { id: 'stacked_bar', label: 'Stacked column', icon: ChartColumnStacked, needs: 'split' },
  { id: 'percent_bar', label: '100% column', icon: Percent, needs: 'split' },
  { id: 'hbar', label: 'Bar', icon: ChartBar },
  { id: 'stacked_hbar', label: 'Stacked bar', icon: ChartBarStacked, needs: 'split' },
  { id: 'pie', label: 'Pie', icon: ChartPie },
  { id: 'donut', label: 'Donut', icon: Donut },
  { id: 'combo', label: 'Column + line', icon: SquareChartGantt, needs: 'two numbers' },
  { id: 'radar', label: 'Radar', icon: Radar },
  { id: 'treemap', label: 'Treemap', icon: LayoutGrid },
  { id: 'funnel', label: 'Funnel', icon: Funnel },
  { id: 'scatter', label: 'Scatter', icon: ChartScatter, needs: 'two numbers' },
  { id: 'sankey', label: 'Sankey', icon: Workflow, needs: 'two groupings' },
  { id: 'matrix', label: 'Heatmap', icon: Grid3x3, needs: 'two groupings' },
  { id: 'kpi', label: 'Number', icon: Hash },
  { id: 'table', label: 'Table', icon: Table },
];

export const chartLabel = (id) => (CHART_TYPES.find((t) => t.id === (id || '')) || CHART_TYPES[0]).label;
